
import { useEffect, useState, useMemo } from "react";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

export default function RealtimeTable() {
  const [tags, setTags] = useState([]);
  const [dados, setDados] = useState([]);
  const [modoAuto, setModoAuto] = useState(true);
  const [socket, setSocket] = useState(null);
  const [loadingTags, setLoadingTags] = useState(false); // começa como falso

  useEffect(() => {
    const delay = setTimeout(() => setLoadingTags(true), 100); // só ativa se demorar

    fetch("/upload")
      .then((res) => res.json())
      .then((data) => {
        clearTimeout(delay); // evita loading se foi rápido
        setTags(data);
        setLoadingTags(false);
      });

    const newSocket = new WebSocket("ws://localhost:5000/ws");
    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.onmessage = (event) => {
      if (modoAuto) {
        const data = JSON.parse(event.data);
        setDados(data);
      }
    };

    return () => {
      socket.onmessage = null;
    };
  }, [socket, modoAuto]);

  const atualizarManual = async () => {
    setLoadingTags(true);
    const res = await fetch("/upload");
    const tagsJson = await res.json();
    setTags(tagsJson);

    const dadosAtualizados = await fetch("/readnow").then((r) => r.json());
    setDados(dadosAtualizados);
    setLoadingTags(false);
  };

  const dadosMap = useMemo(() => {
    const m = new Map();
    dados.forEach((d) => m.set(d.desc, d.value));
    return m;
  }, [dados]);

  const Row = ({ index, style }) => {
    const tag = tags[index];
    const valor = dadosMap.get(tag.desc);
    const foraLimite =
      typeof valor === "number" &&
      (valor < tag.limiteMin || valor > tag.limiteMax);
    const cor =
      valor === undefined
        ? "bg-gray-600"
        : foraLimite
        ? "bg-red-600 text-white"
        : "bg-green-700 text-white";

    const endereco =
      tag.type === "bool"
        ? `${tag.area ?? ""}${tag.db ?? ""}.DBX${tag.byte ?? ""}.${tag.bit ?? ""}`
        : tag.type
        ? `${tag.area ?? ""}${tag.db ?? ""}.DB${tag.type[0].toUpperCase()}${tag.byte ?? ""}`
        : "-";

    return (
      <div style={style} className={`grid grid-cols-6 text-sm border-b border-gray-700 ${cor}`}>
        <div className="px-2 py-1">{tag.plc ?? "-"}</div>
        <div className="px-2 py-1">{tag.favorito ? "⭐ " : ""}{tag.desc}</div>
        <div className="px-2 py-1">{endereco}</div>
        <div className="px-2 py-1">{valor !== undefined ? String(valor) : "-"}</div>
        <div className="px-2 py-1">{tag.unidade ?? "-"}</div>
        <div className="px-2 py-1">{(tag.limiteMin ?? "-") + " a " + (tag.limiteMax ?? "-")}</div>
      </div>
    );
  };

  if (loadingTags) {
    return <div className="p-4 text-white">⏳ Carregando tags...</div>;
  }

  return (
    <div className="p-4 h-full flex flex-col">
      <h2 className="text-2xl font-bold mb-4">📋 Tabela em Tempo Real</h2>

      <div className="mb-4 flex items-center gap-4">
        <label className="text-sm text-white">
          <input
            type="checkbox"
            checked={modoAuto}
            onChange={() => setModoAuto(!modoAuto)}
            className="mr-2"
          />
          Atualização automática
        </label>
        {!modoAuto && (
          <>
            <button
              onClick={atualizarManual}
              className="bg-blue-500 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm"
            >
              Atualizar agora
            </button>
          </>
        )}
      </div>

      <div className="grid grid-cols-6 bg-gray-700 text-white text-sm font-semibold border border-gray-700">
        <div className="px-2 py-1">PLC</div>
        <div className="px-2 py-1">Descrição</div>
        <div className="px-2 py-1">Endereço</div>
        <div className="px-2 py-1">Valor</div>
        <div className="px-2 py-1">Unidade</div>
        <div className="px-2 py-1">Limites</div>
      </div>

      <div className="flex-1 border border-gray-700">
        <AutoSizer>
          {({ height, width }) => (
            <List
              height={height}
              itemCount={tags.length}
              itemSize={40}
              width={width}
            >
              {Row}
            </List>
          )}
        </AutoSizer>
      </div>
    </div>
  );
}
